export const DateTimeFormatter = new Intl.DateTimeFormat('en-US', {
	day: '2-digit',
	month: '2-digit',
	year: 'numeric',
});
